import * as React from 'react';
import { SVGProps } from 'react';

const ClassroomIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.167 6.167H13V5a2 2 0 0 1 2-2h1.167v1.167a2 2 0 0 1-2 2ZM13 13a3.905 3.905 0 0 1-3.905-3.905M9.095 9.095c0-1.704.781-2.929 2.343-2.929M13 13a3.905 3.905 0 0 0 3.905-3.905"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.905 9.095c0-1.704-.781-2.929-2.343-2.929M14.562 6.167c-.781 0-1.224.25-1.562.25-.338 0-.781-.25-1.562-.25M20.625 13H7.375a2 2 0 1 0 0 4h13.25M20.12 13v4M18.625 17H5.375a2 2 0 1 0 0 4h13.25M18.12 17v4"
    />
  </svg>
);
export default ClassroomIcon;
